// TODO: continue here to replace createStore and createMockStore: https://redux.js.org/usage/migrating-to-modern-redux#store-setup-with-configurestore
import { createStore, applyMiddleware, combineReducers, Store } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { AppState } from "./app-state";
import UIReducer from "./ui/ui-reducer";
import entityReducer from "./entity/entity-reducer";
import userReducer from "./user/user-reducer";
import { companyReducer } from "./company/company-reducer";

const rootReducer = combineReducers<AppState>({
    ui: UIReducer,
    entity: entityReducer,
    user: userReducer,
    company: companyReducer
});

function configureStore(): Store<AppState> {
    const store = createStore(
        rootReducer,
        composeWithDevTools(applyMiddleware(thunk))
    );
    return store;
}
export default configureStore;